import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'

export default {
  async setLookups({ commit, dispatch, state }, keys) {
    let _keys = keys.filter(k => !state.lookups[k])
    if (_keys.length) {
      const r = await startLoading(dispatch, 'setLookups', () =>
        http.post('lookup/ByKeys', keys)
      )
      commit(types.SET_LOOKUPS, [keys, r.data])
    }
  },
  async getLookupsByGroup({ commit, dispatch, state }, { className, group }) {
    const r = await startLoading(dispatch, 'getLookupsByGroup', () =>
      http.get(`lookup/ByGroup?className=${className}&group=${group}`)
    )
    commit(types.SET_GROUPS, r.data)
  },
  async getLookupValuesZeus({ commit, dispatch }, key) {
    const r = await startLoading(dispatch, 'getLookupValuesZeus', () =>
      http.get(`app/GetLookupValues?key=${key}`)
    )
    commit(types.SET_LOOKUPS_ZEUS, [key, r.data])
  },
  async setTimeZones({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'setTimeZones', () =>
      http.get(`lookup/TimeZones`)
    )
    let _data = Array.from(new Set(r.data)).sort(function (a, b) {
      if (a[0] === b[0]) {
        var x = a['name']
        var y = b['name']
        return x < y ? -1 : x > y ? 1 : 0
      }
      return a[0] - b[0]
    })
    commit(types.SET_TIMEZONES, _data)
  },
  async getLookupsByParent({ commit, dispatch, state }, [key, parentId]) {
    const r = await startLoading(dispatch, 'getLookupsByParent', () =>
      http.get(`lookup/ByParent?parentId=${parentId}`)
    )
    return r.data
  },
  async upsertLookup({ commit, dispatch, state }, lookup) {
    const r = await startLoading(dispatch, 'upsertLookup', () =>
      http.post('lookup/Upsert', lookup)
    )
    commit(types.UPSERT_LOOKUP, [lookup, r.data])
    return r
  },
  async deleteLookup({ commit, dispatch, state }, lookup) {
    let _lookup = Object.assign({}, lookup)
    _lookup.isActive = false
    const r = await startLoading(dispatch, 'deleteLookup', () =>
      http.post('lookup/Delete', _lookup)
    )
    if (r.data[0].Results === '') {
      commit(types.DELETE_LOOKUP, lookup)
    }
    return r
  },
  async upsertGroup({ commit, dispatch, state }, { id, name }) {
    let data = {
      id: id,
      text: name
    }
    const r = await startLoading(dispatch, 'deleteLookup', () =>
      http.post('lookup/UpsertGroup', data)
    )
    if (r.data === id) {
      commit(types.UPSERT_GROUP, data)
    }
    return r
  },
  async getAllVehicleMakes({ commit, dispatch }) {
    let _years = await http.get(`WorkOrder/GetVehicleYear`)
    const makes = []
    const r = await startLoading(dispatch, 'getAllVehicleMakes', () =>
      http.get(`WorkOrder/GetVehicleYear`)
    )
    _years = r.data
    for (let yr of _years) {
      const _makes = await startLoading(dispatch, 'getAllVehicleMakes', () =>
        http.get(`WorkOrder/GetVehicleMake?year=${yr}`)
      )
      const vehData = _makes.data
      for (let d of vehData) {
        makes.push(d.text)
      }
    }
    let _makes = Array.from(new Set(makes)).sort()
    return _makes
  },
  async getAllRegions({ commit, dispatch }) {
    // need a call to get regions from the database
    // SELECT DISTINCT [Region] FROM [TimeZone]
  },
  async getInsuranceCompanies({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getInsuranceCompanies', () =>
      http.get(`lookup/InsuranceCompanies`)
    )
    commit(types.SET_INSURANCE_COMPANIES, r.data)
  },
  async processReviewRequestQueue({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'sendReviewRequestReport', () =>
      http.post('servicerequest/processrequestsqueue')
    )
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/actions.js